<template>
  <v-container class="max-width-1200">

    <v-row class="text-justify justify-center">
      <v-col cols="12" sm="6">

        <v-row class="justify-center">
          <v-col>
            <v-row>
              <v-col class="pb-0 headline text-uppercase">
                {{ $t('energyMonitor.software.title') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="display-1">
                {{ $t('energyMonitor.software.subtitle')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t('energyMonitor.software.text.01')}}<br>
                {{ $t('energyMonitor.software.text.02')}}<br>
                {{ $t('energyMonitor.software.text.03')}}
              </v-col>
            </v-row>
          </v-col>
        </v-row>

      </v-col>
      <v-col cols="12" sm="6" class="align-center d-flex">
        <v-img
          src="@/assets/em/em_mockup_01.png"
          max-width="450"
          contain
          class="ml-12 mr-auto"
          style="width: calc(100% - 48px);">
        </v-img>
      </v-col>
    </v-row>

    <v-row>
      <v-col>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'EnergyMonitorSoftware',
    extends: DataComponentBase,

    data: () => ({

    }),

    methods: {

    },
  }
</script>
